// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    production: false,
    firebaseConfig: {
        apiKey: "AIzaSyB_oR8JBfmDTT12YGB182IbulFL85m_ENo",
        authDomain: "adithidevo-3375e.firebaseapp.com",
        projectId: "adithidevo-3375e",
        storageBucket: "adithidevo-3375e.appspot.com",
        messagingSenderId: "13262243522",
        appId: "1:13262243522:web:5450059d84ff6f1447dd5b",
        measurementId: "G-GGMLQJTRE3",
        databaseURL: "https://adithidevo-3375e.firebaseio.com/",
         vapidKey: "BLh36FYPEdLbh5FeTjot-IOUvxcHuKXeMnBINFdwszSR11y0V3xP1JCWAeLBsDndz"
    },
  };        
